import React from 'react'
import Link from 'gatsby-link'
import get from 'lodash/get'
import Helmet from 'react-helmet'
import styled from 'styled-components'
import anime from 'animejs'

import Footer from '../components/footer'
import arrow from "./arrow.svg";
import bg from "./bg.png";

class BlogIndex extends React.Component {
  componentDidMount(){
    var playPause = anime({
      targets: '.projectItem',
      opacity: [0,1],
      scale: [1.01, 1],
      translateY: [5, 1],
      delay: function(el, i, l) { return i * 50; },
      direction: 'alternate',
      loop: false,
      autoplay: true
    });
  }

  render() {
    const siteTitle = get(this, 'props.data.site.siteMetadata.title')
    const posts = get(this, 'props.data.allMarkdownRemark.edges')

    const Intro = styled.div.attrs({className: 'projIntro'})`
      text-align: center;
      font-size: 2.75em;
          line-height: 1.26em;
      /* font-weight: 700; */
      -webkit-letter-spacing: -.5px;
      -moz-letter-spacing: -.5px;
      -ms-letter-spacing: -.5px;
      letter-spacing: -.5px;
      background-position: center;
      color: #000000;
      font-family: "Publico";
      /* text-align: center; */
      padding-left: 1em;
      padding-top: 4em;
      padding-bottom: 2.5em;
    `;
    const ActiveIndicator = styled.span `

    `;

    const Project = styled(Link).attrs({className: 'projectItem'})`
      min-width: 325px;
      ${'' /* flex-grow: 1; */}
      flex-basis: calc(33.3% - .5em);
      margin: .25em;
      text-decoration: none;
      overflow: hidden;
      margin-bottom: 1em;
      &:hover .proj-arrow{
        right: .25em !important;
      }
      &:hover .thumbImg{
        transform: scale(.965);
      }
    `
    const ThumbImg = styled.img.attrs({className: 'thumbImg'})`
    width: 100%;
    height: 250px;
    object-fit: cover;
    transform: scale(1);
    border-radius: 2px;
    transition: transform .25s cubic-bezier(.25,.03,.1,1.01);
    `

    return (<div>
      <Helmet title={get(this, 'props.data.site.siteMetadata.title')}/>
      <div>
        <Intro className="root-width rw-pad">
          I am a designer and software<br/>developer based in Los Angeles
          <div className="intro-summary">
            I am currently a student at the University of Southern California's Iovine and Young Academy, studying Software Development and Interaction Design.
          </div>
        </Intro>
      </div>
      <div className="projectHolder">
        {
          posts.map(post => {
            if (post.node.path !== '/404/') {
              const title = get(post, 'node.frontmatter.title') || post.node.path
              const thumbImage = post.node.frontmatter.thumb.childImageSharp.resize.src;
              const color = post.node.frontmatter.color;
              const tags = post.node.frontmatter.tags;
              const active = post.node.frontmatter.active;
              const type = post.node.frontmatter.type;

              if (type == "project"){
                    return (<Project to={post.node.frontmatter.path} key={post.node.frontmatter.path}>
                    <ThumbImg src={thumbImage}></ThumbImg>
                  <div style={{
                      display:"flex",
                      flexDirection:"row",
                      padding: ".5em",
                      paddingTop: ".75em",
                      alignItems: "center"
                    }}>
                    <div style={{flexGrow: 1}}>
                      <div className="project-title">{title}{active?<span className="activeIndicator">Active</span>:null}</div>
                    <div className="project-tags">{
                      tags.map((tag, i)=>
                        <span>{tag}{(i<tags.length - 1)? ", ": ""}</span>
                      )}</div>
                    </div>
                    <div className="proj-arrow" style={{flexBasis: "30px", textAlign: "right", right: "-30px", position: "relative", transition: "right .25s cubic-bezier(.25,.03,.1,1.01)"}}>
                      <img src={arrow}></img>
                    </div>
                </div>
                  </Project>)
            }
            }
          })
        }

      </div>
      <Footer />
    </div>)
  }
}

BlogIndex.propTypes = {
  route: React.PropTypes.object
}

export default BlogIndex

export const pageQuery = graphql `
  query IndexQuery {
    site {
      siteMetadata {
        title
      }
    }
    allMarkdownRemark(sort: { fields: [frontmatter___date], order: DESC }) {
      edges {
        node {
          excerpt
          frontmatter{
            path
            tags
            # date(formatString: "DD MMMM, YYYY")
            active
          }
          frontmatter {
            title
            color
            type
            thumb {
              childImageSharp {
                resize(width: 800) {
                  src
                }
              }
            }
          }
        }
      }
    }
  }
`

// Intro Old
    // font-size: 3.25em;
    // font-weight: 700;
    // letter-spacing: -.5px;
    // background-position: center;
    // color: #000000;
    // font-family: "Publico";
    // text-align: center;
    // padding-top: 4em;
    // padding-bottom: 4em;



// WEBPACK FOOTER //
// ./src/pages/index.js